import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, buttonVariants } from '@repo/ui-primitives';
import { cn } from '@repo/ui-primitives/utils';
import { AlertCircle, AlertTriangle, X } from 'lucide-react';
export function ConfirmModal(param) {
    let { title, description, icon, type, open, cancelBtnText = 'No, go back', confirmBtnText = 'Confirm', children, disabled, onClose, onCancel, onConfirm, hideCancelButton = false } = param;
    const handleCancel = ()=>{
        void (onCancel === null || onCancel === void 0 ? void 0 : onCancel());
        onClose();
    };
    const getIcon = ()=>{
        if (icon) return icon;
        if (type === 'error') return /*#__PURE__*/ _jsx(AlertCircle, {
            className: "h-6 w-6 text-destructive"
        });
        if (type === 'warning') return /*#__PURE__*/ _jsx(AlertTriangle, {
            className: "h-6 w-6 text-yellow-500"
        });
        return /*#__PURE__*/ _jsx(AlertCircle, {
            className: "h-6 w-6 text-primary"
        });
    };
    const getButtonClassName = ()=>{
        if (type === 'error') return cn(buttonVariants({
            variant: 'destructive'
        }));
        if (type === 'warning') return cn(buttonVariants({
            variant: 'default'
        }));
        return cn(buttonVariants({
            variant: 'default'
        }));
    };
    return /*#__PURE__*/ _jsx(AlertDialog, {
        open: open,
        onOpenChange: (open)=>!open && onClose(),
        children: /*#__PURE__*/ _jsxs(AlertDialogContent, {
            className: "sm:max-w-[500px]",
            children: [
                /*#__PURE__*/ _jsx(AlertDialogHeader, {
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-start gap-3",
                        children: [
                            getIcon(),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex-1",
                                children: [
                                    /*#__PURE__*/ _jsx(AlertDialogTitle, {
                                        children: title
                                    }),
                                    description && /*#__PURE__*/ _jsx(AlertDialogDescription, {
                                        className: "mt-2",
                                        children: description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("button", {
                                onClick: onClose,
                                className: "rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100",
                                children: /*#__PURE__*/ _jsx(X, {
                                    className: "h-4 w-4"
                                })
                            })
                        ]
                    })
                }),
                children && /*#__PURE__*/ _jsx("div", {
                    className: "py-4",
                    children: children
                }),
                /*#__PURE__*/ _jsxs(AlertDialogFooter, {
                    children: [
                        !hideCancelButton && /*#__PURE__*/ _jsx(AlertDialogCancel, {
                            onClick: handleCancel,
                            children: cancelBtnText
                        }),
                        /*#__PURE__*/ _jsx(AlertDialogAction, {
                            className: getButtonClassName(),
                            disabled: disabled,
                            onClick: ()=>void (onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm()),
                            children: confirmBtnText
                        })
                    ]
                })
            ]
        })
    });
}
